// Waste & Meals — digits and quantity display.
//
// Branch staff type on Arabic keyboards, so Arabic-Indic digits and the
// Arabic decimal separator (٫) must be accepted verbatim. The server folds
// them too; this keeps the field usable before it is ever submitted.

const AR_DIGITS = "٠١٢٣٤٥٦٧٨٩";
const FA_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

export function toLatinDigits(input) {
    let s = String(input ?? "");
    for (let i = 0; i < 10; i++) {
        s = s.split(AR_DIGITS[i]).join(String(i)).split(FA_DIGITS[i]).join(String(i));
    }
    return s.replace(/٫/g, ".").replace(/[٬,]/g, "");
}

/** Keep only what can be part of a positive decimal, and at most one dot. */
export function sanitizeQty(raw, allowsDecimal) {
    let s = toLatinDigits(raw).replace(/[^\d.]/g, "");
    if (!allowsDecimal) return s.replace(/\./g, "");
    const first = s.indexOf(".");
    if (first === -1) return s;
    return s.slice(0, first + 1) + s.slice(first + 1).replace(/\./g, "");
}

export function fmtQty(v, lang) {
    if (v === null || v === undefined || v === "") return "";
    const n = Number(v);
    if (Number.isNaN(n)) return "";
    return new Intl.NumberFormat(lang === "ar" ? "ar-SA" : "en-US", {
        maximumFractionDigits: 3,
    }).format(n);
}

/** "12.4 كجم · 35 حبة" — one value per unit, never mixed. */
export function fmtUnitTotals(totals, unitNames, lang) {
    const parts = Object.entries(totals || {})
        .filter(([, v]) => v !== null && v !== undefined && v !== 0)
        .map(([unit, v]) => `${fmtQty(v, lang)} ${(unitNames || {})[unit] || unit}`);
    return parts.join(" · ");
}
